import { Select } from '@cian/ui-kit';
import { Input, MaskedInput } from '@cian/ui-kit/prev';

import * as React from 'react';

import { CustomFormField } from '../../../../CustomFormField';
import { FormFooterWithPrivacyPolicy } from '../../../../FormFooterWithPrivacyPolicy';

import { EPlacementApplicationFormFields } from '../../../enums';

import { PHONE_MASK } from '../../constants';
import { companyTypeSelectOptions } from '../../maps';

import * as styles from './PlacementApplicationFormView.css';
import { IPlacementApplicationFormViewProps } from './types';

export const PlacementApplicationFormView: React.FC<IPlacementApplicationFormViewProps> = props => {
  const {
    boundActions,
    checkFormFieldInvalid,
    isDisableFieldsOnPending,
    getFormFieldErrorMessage,
    getFormFieldValue,
    onBlur,
    onSubmit,
    pending,
  } = props;

  return (
    <form className={styles['form-container']} onSubmit={onSubmit}>
      <div className={styles['form-group']}>
        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.CompanyName)}
          label="Название компании"
        >
          <Input
            custom={{ invalid: checkFormFieldInvalid(EPlacementApplicationFormFields.CompanyName) }}
            disabled={isDisableFieldsOnPending && pending}
            onBlur={onBlur(EPlacementApplicationFormFields.CompanyName)}
            onChange={boundActions.setCompanyNameFieldValueAction}
            placeholder="Введите название компании"
            value={getFormFieldValue(EPlacementApplicationFormFields.CompanyName)}
          />
        </CustomFormField>
        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.CompanyType)}
          label="Вид деятельности"
        >
          <Select
            disabled={isDisableFieldsOnPending && pending}
            invalid={checkFormFieldInvalid(EPlacementApplicationFormFields.CompanyType)}
            onBlur={onBlur(EPlacementApplicationFormFields.CompanyType)}
            onChange={boundActions.setCompanyTypeFieldValueAction}
            options={companyTypeSelectOptions}
            placeholder="Выберите вид деятельности"
            value={getFormFieldValue(EPlacementApplicationFormFields.CompanyType)}
          />
        </CustomFormField>

        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.Phone)}
          label="Номер телефона"
        >
          <MaskedInput
            custom={{
              alwaysShowMask: false,
              invalid: checkFormFieldInvalid(EPlacementApplicationFormFields.Phone),
              mask: PHONE_MASK,
            }}
            disabled={isDisableFieldsOnPending && pending}
            onBlur={onBlur(EPlacementApplicationFormFields.Phone)}
            onChange={boundActions.setPhoneFieldValueAction}
            placeholder="+7"
            value={getFormFieldValue(EPlacementApplicationFormFields.Phone)}
          />
        </CustomFormField>

        <CustomFormField
          containerClassName={styles['form-element']}
          errorMessage={getFormFieldErrorMessage(EPlacementApplicationFormFields.Email)}
          label="E-mail"
        >
          <Input
            custom={{ invalid: checkFormFieldInvalid(EPlacementApplicationFormFields.Email) }}
            disabled={isDisableFieldsOnPending && pending}
            onBlur={onBlur(EPlacementApplicationFormFields.Email)}
            onChange={boundActions.setEmailFieldValueAction}
            placeholder="Введите e-mail"
            value={getFormFieldValue(EPlacementApplicationFormFields.Email)}
          />
        </CustomFormField>
      </div>

      <FormFooterWithPrivacyPolicy buttonDisabled={pending} submitButtonTitle="Отправить заявку" />
    </form>
  );
};

PlacementApplicationFormView.displayName = 'PlacementApplicationFormView';
